var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('basic-setting')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }